export class GuestProfile
{
	guestProfileId: number;
	guestProfileDate: Date;
}
